import { LocalizedValue, createLocalizedValue } from '../LocalizedValue';
import dayjs from '../../Utils/dayjs';
import { languagePriority } from '../LocalizedEntity';

export type MediaOverlay = {
  startTime: string;
  endTime?: string;
  text: LocalizedValue[];
};

// Utility functions
function timeToSeconds(time: string): number {
  const split = time.split(':').reverse();
  const seconds = split.length > 0 ? Number(split[0]) : 0;
  const minutes = split.length > 1 ? Number(split[1]) : 0;
  const hours = split.length > 2 ? Number(split[2]) : 0;
  return hours * 3600 + minutes * 60 + seconds;
}

function secondsToTime(videoSeconds: number): string {
  const duration = dayjs.duration(videoSeconds, 'seconds');
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const milliseconds = duration.milliseconds().toFixed(0);
  return `${hours.toString(10).padStart(2, '0')}:${minutes.toString(10).padStart(2, '0')}:${seconds
    .toString(10)
    .padStart(2, '0')}.${milliseconds.padStart(3, '0')}`;
}

export function getOverlayStartSeconds(o: MediaOverlay): number {
  return timeToSeconds(o.startTime);
}

export function getOverlayEndSeconds(o: MediaOverlay): number | undefined {
  return o.endTime ? timeToSeconds(o.endTime) : undefined;
}

export function getOverlayDefaultText(o: MediaOverlay): string {
  for (const lang of languagePriority) {
    const entry = o.text.find((l) => l.lang === lang);
    if (entry) return entry.value ?? '';
  }
  return o.text[0]?.value ?? '';
}

export function getOverlayText(o: MediaOverlay, language: string): string {
  return o.text.find((l) => l.lang.toLowerCase() === language.toLowerCase())?.value ?? getOverlayDefaultText(o);
}

export function setOverlayStartSeconds(o: MediaOverlay, seconds: number): MediaOverlay {
  return { ...o, startTime: secondsToTime(seconds) };
}

export function setOverlayEndSeconds(o: MediaOverlay, seconds?: number): MediaOverlay {
  return { ...o, endTime: seconds ? secondsToTime(seconds) : undefined };
}

/** @deprecated Use raw object instead */
export function createMediaOverlay(json?: Partial<MediaOverlay>): MediaOverlay {
  return {
    startTime: json?.startTime ?? '00:00:00.000',
    endTime: json?.endTime,
    text: (json?.text ?? []).map((t: any) => createLocalizedValue(t)),
  };
}
